<template>
    <div class="card p-3 h-100">
      <h2>Resources</h2>
      <hr class="mt-3 mb-3">
      <ul class="list-group" v-if="resources && resources.length > 0">
        <li v-for="(resource, index) in resources" :key="'resource-' + index" class="list-group-item mb-3">
          <div v-if="resource.link">
            {{resource.description}} 
            <a target="_blank" :href="resource.link">
              <button class="btn btn-success btn-sm float-right">View</button>
            </a>
          </div>
          <div v-if="resource.uploadId">
            {{resource.description}} 
            <button class="btn btn-success btn-sm float-right" @click="downloadFile(resource.uploadId)">View</button>
          </div>
        </li>
      </ul>
      <p class="py-5 lead text-muted text-center" v-else>There are no resources to show</p>
    </div>
</template>

<script>
  import UploadsService from '../../services/UploadsService';

  export default {
    name: 'resources-card',

    components: {
     
    },

    props:[
      'resources'
    ],

    data() {
      return {
       
      };
    },

    computed:{
        
    },

    methods: {
      async downloadFile(uploadId) {
        try {
          // Get the signed download url from S3
          let fileRes = await UploadsService.getSignedDownload(uploadId);
          const signedUrl = fileRes.data;
          
          // Open a new tab/window with the signed url
          window.open(signedUrl);
        }
        catch(err) {
          alert('Oops, something went wrong while getting the file. Please try again.')
        }
      }
    }
  }
</script>